export const THINKING_PARTS = [
  'container',
  'label',
  'expandButton',
  'expandIndicator',
  'expandedContent',
] as const;
